import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["summaryText", "checkbox"]

  updateSummary() {
    const checked = this.checkboxTargets.filter(cb => cb.checked)
    const names = checked.map(cb => cb.closest("label").querySelector("span").textContent.trim())

    let text
    if (names.length === 0) {
      text = "Recipients (0)"
    } else if (names.length <= 2) {
      text = `Notifying ${this.#toSentence(names)}`
    } else {
      const remaining = names.length - 2
      text = `Notifying ${names.slice(0, 2).join(", ")} and ${remaining} ${remaining === 1 ? "other" : "others"}`
    }

    this.summaryTextTarget.textContent = text
  }

  #toSentence(arr) {
    if (arr.length <= 1) return arr.join("")
    return `${arr.slice(0, -1).join(", ")} and ${arr[arr.length - 1]}`
  }
}
